var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 2428.8 457.4",
  style: {
    "enableBackground": "new 0 0 2428.8 457.4"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_00000001626860189520780590000017370657891535552682_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M274.2 67.5h198.2v56.3H333.7v66.7h121.8v55.9H333.7v118.2h-59.5V67.5zM720.5 145.5v219.1h-53.9v-25.3c-16.1 17.3-39 30.5-70 30.5-63.5 0-108.5-50.7-108.5-115.8 0-65.9 46.2-114.2 108.5-114.2 31 0 53.5 13.7 70 31.8v-26.1h53.9zm-53.1 109.3c0-34.2-25.3-63.1-61.5-63.1-36.6 0-61.1 28.9-61.1 63.1 0 35 24.9 63.5 61.1 63.5s61.5-28.9 61.5-63.5zM752 328l30.2-35.8c15.7 18.9 38.6 30.5 60.7 30.5 17.3 0 30.2-8.8 30.2-21.3 0-8-5.2-14.1-15.7-18.9-12.1-5.6-41-14.9-54.3-21.7-24.9-12.1-37.8-31.4-37.8-56.7 0-38.2 32.2-65.9 82-65.9 28.1 0 55.5 9.2 76.8 31.4L896 206.2c-16.5-15.7-35.4-21.7-50.2-21.7-15.7 0-24.9 8.4-24.9 18.5 0 7.6 4.8 15.3 19.3 20.1 13.7 5.2 35.4 12.5 52.7 21.3 24.5 12.9 37 29.7 37 55.5 0 39.8-33.8 70.4-87.2 70.4-35.2-.1-68.6-14.2-90.7-42.3zM1125.7 351.7c-17.3 11.6-42.2 18.1-64.7 18.1-50.2 0-76.4-29.8-76.4-86.4v-90.5h-35.8v-47.4H985V67.9h56.3v77.6h72.4v47.4h-72.4v86.8c0 25.3 9.7 38.6 31 38.6 14.1 0 25.7-5.2 36.6-11.2l16.8 44.6zM1144.6 313.9l34.2-41.4c19.7 26.9 48.6 41.4 78.8 41.4 24.9 0 42.6-13.3 42.6-31.8 0-14.9-11.7-23.7-26.9-30.9-18.9-8.9-43.4-16.1-64.3-27.7-26.1-14.9-47-37-47-74 0-49 41-86.8 101.3-86.8 34.6 0 69.9 12.1 97.7 40.2l-31.8 43.4c-17.7-18.5-44.6-27.7-65.1-27.7-23.7 0-38.2 11.7-38.2 28.5 0 14.9 12.1 23.3 24.1 29.4 15.7 7.2 45.4 18.5 65.5 28.5 28.9 14.1 50.7 36.2 50.7 74 0 52.7-43.8 90.4-108.9 90.4-45.6 0-87.4-18.9-112.7-55.5zM1636.6 254.8c0 63.5-45 115-108.1 115-30.6 0-52.7-13.3-68.7-30.5v115.3H1403V145.5h56.3v26.9c16.1-18.5 38.6-32.6 69.5-32.6 62.8 0 107.8 51.5 107.8 115zm-57.1.4c0-34.6-24.1-62.7-60.7-62.7-36.2 0-60.3 28.1-60.3 62.7s24.1 62.7 60.3 62.7c36.6 0 60.7-28.1 60.7-62.7zM1675.3 145.5h54.3v29.3c13.7-24.1 34.6-35.4 60.3-35.4 9.1.1 18 1.7 26.5 4.8l-4.8 54.3c-8.4-2.8-17.2-4.3-26.1-4.4-29.8 0-53.5 18.5-53.5 66.3v104.1h-56.7v-219zM1844.2 86c0-19.7 15.3-34.6 35-34.6s35 14.9 35 34.6c0 20.1-15.3 35-35 35s-35-14.9-35-35zm6.4 278.6V145.5h56.7v219.1h-56.7zM1956.4 145.5h55.5V176c11.2-20.5 36.2-36.6 68.7-36.6 44.2 0 85.6 29.4 85.6 91.3v133.9h-56.7V246c0-35.4-18.9-54.3-46.2-54.3-29.8 0-50.2 22.5-50.2 55.5v117.3h-56.7v-219zM2428.8 145.5v197.4c0 71.1-51.1 114.6-121.4 114.6-38.6 0-74.8-13.3-100.5-31.8L2229 383c19.7 13.3 47.4 25.7 76.8 25.7 44.6 0 68.3-26.5 68.3-60.7v-11.2c-15.3 16.9-37 28.1-67.5 28.1-64.7 0-109.4-47.8-109.4-112.1 0-66.3 49.4-113 111.8-113 29.8 0 51.9 12.5 67.5 29.8v-24.1h52.3zm-53.1 107.7c0-35.4-25.7-61.5-60.7-61.5s-60.7 26.1-60.7 61.5c0 35.8 25.7 62.3 60.7 62.3s60.7-26.9 60.7-62.3z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: -.003,
  y1: 362.798,
  x2: 181.536,
  y2: 362.798,
  gradientTransform: "matrix(1 0 0 -1 .006 460.002)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    "stopColor": "#fb8d63"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    "stopColor": "#fda96c"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.4 93.8 160.2 0l10.1 14.4c19.6 28 12.8 66.5-15.1 86.1L21.3 194.4 11.2 180c-19.6-28-12.8-66.5 15.2-86.2z",
  style: {
    "fill": "url(#SVGID_1_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000176011520467016574360000004457828348418377643_",
  gradientUnits: "userSpaceOnUse",
  x1: .737,
  y1: 243.988,
  x2: 182.268,
  y2: 243.988,
  gradientTransform: "matrix(1 0 0 -1 0 460.008)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    "stopColor": "#fead6d"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: .37,
  style: {
    "stopColor": "#fead6d"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    "stopColor": "#feb26d"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#SVGID_00000176011520467016574360000004457828348418377643_)"
  },
  d: "M27.1 212.7 161 118.8l10.1 14.4c19.6 28 12.8 66.5-15.1 86.1L22 313.2l-10.1-14.4c-19.6-28-12.8-66.5 15.2-86.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000151536299825687102340000018281564203430283170_",
  gradientUnits: "userSpaceOnUse",
  x1: 1.469,
  y1: 125.178,
  x2: 183.008,
  y2: 125.178,
  gradientTransform: "matrix(1 0 0 -1 .004 460.004)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: .04,
  style: {
    "stopColor": "#fdac6b"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: .95,
  style: {
    "stopColor": "#fdbd7c"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#SVGID_00000151536299825687102340000018281564203430283170_)"
  },
  d: "m27.8 331.5 133.9-93.8 10.1 14.4c19.6 28 12.8 66.5-15.1 86.1L22.8 432l-10.1-14.4c-19.6-27.9-12.9-66.5 15.1-86.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000105408555919609947320000013564706844981616314_",
  gradientUnits: "userSpaceOnUse",
  x1: 127.108,
  y1: 210.072,
  x2: 86.314,
  y2: 280.74,
  gradientTransform: "matrix(1 0 0 -1 0 460)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: .15,
  style: {
    "stopColor": "#feba7d"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: .76,
  style: {
    "stopColor": "#febe7f"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#SVGID_00000105408555919609947320000013564706844981616314_)"
  },
  d: "M92.8 210c-20.7 26.8-37.3 56.6-49.4 88.2l112.5-78.9c28-19.6 34.8-58.2 15.1-86.2l-1.4-2.1c-27.5 24.8-54.3 50-76.8 79z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000004534206286991547390000000015960781073832069_",
  gradientUnits: "userSpaceOnUse",
  x1: 40.109,
  y1: 306.302,
  x2: 161.669,
  y2: 387.882,
  gradientTransform: "matrix(1 0 0 -1 0 460)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    "stopColor": "#feb16e"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    "stopColor": "#ffb76e"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#SVGID_00000004534206286991547390000000015960781073832069_)"
  },
  d: "M152 83c-37.8 26.2-84.3 35.7-125.9 55.3-8.8 4.2-17.4 8.8-25.6 13.9 1.2 10 4.9 19.6 10.7 27.8l10.1 14.4 133.9-93.8c15.4-10.8 25.1-28 26.2-46.8-8 11.4-18 21.3-29.4 29.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_00000090274541484029448500000015301538914514857661_",
  gradientUnits: "userSpaceOnUse",
  x1: 46.301,
  y1: 56.419,
  x2: 179.656,
  y2: 189.774,
  gradientTransform: "matrix(1 0 0 -1 0 460)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: .04,
  style: {
    "stopColor": "#fca56c"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: .95,
  style: {
    "stopColor": "#fea368"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#SVGID_00000090274541484029448500000015301538914514857661_)"
  },
  d: "M180.9 271.5c-30.9 5.3-61.5 15.4-84.6 36.1-28.7 25.7-41.8 64.6-43 103.1l103.3-72.4c21.4-15.1 31-41.7 24.3-66.8z"
}))));
export default __webpack_public_path__ + "static/media/fastspring-logo.f9fea3db.svg";
export { SvgComponent as ReactComponent };